export const getAccountApplicationUpdateSubscriptionCmd = (
  accountId?: number | string,
  apiToken?: string,
  unsubscribe?: boolean
) => `0=${apiToken}|1=${accountId}|16=${unsubscribe ? 2 : 1}`;
